/* eslint-disable */
/**
 * ReyDRLocalizations are specific to datbase columns and tables.
 * The exact structure replicated in each language supported.
 *
 * Explanation of structure by Example with comments:
 *   Central: {   //#1
 *       DMSBranch: DMSBranch, //#2
 *       DMSStore: DMSStore, //#3
 *       SpecializedLocaleTable: { //#4
 *           AlertTypeLocale: AlertTypeLocale,  //#5
 *       },
 *   },
 *
 * #1:  Central refers to the database.
 *
 * #2:  Pull translated column names for DMSBranch table columns.  For example. DMSBranch.DMSBranhId = 'Business Unit'
 *
 * #3:  Pull translated column names for DMSStore.  For Example: DMSStore.DMSStoreId = 'Group'
 *
 * #4:  SpecializedLocaleTables are the tables in the database that typically end in locale and store localizationed
 *      strings as its row data.
 *
 * #5:  Each AlertTypeId will reference an alerttypename.
 */


export const UILocalizationFRCA = {
	NoItemsFoundFor: `Aucun article trouvé pour {0}`,
	Back: `Reculer`,
	Profile: `Profil`,
	Vehicle: `Véhicule`,
	Calendar: `Calendrier`,
	Menu: `Menu`,
	DealerLogo: `Logo concessionnaire`,
	Welcome: `Bienvenue!`,
	WelcomeBack: `Bon retour!`,
	VisitedBefore: `Nous avez-vous déjà rendu visite?`,
	Hello: `Bonjour,`,
	GetApptAdded: `Ajoutons votre rendez-vous!`,
	WhatName: `Quel est votre nom?`,
	FirstName: `Prénom *`,
	LastName: `Nom de famille *`,
	Proceed: `Procéder`,
	Email: `Adresse courriel`,
	Password: `Mot de passe *`,
	CreateAcct: `Créer compte`,
	Login: `Connexion`,
	HaveAccount: `Vous avez un compte?`,
	SignUp: `Inscrivez-vous`,
	FieldsCreateAcct: `Veuillez saisir chaque champ ci-dessous pour créer votre compte.`,
	ConfirmPassword: `Veuillez confirmer votre mot de passe *`,
	EmailLengthError: `L'adresse courriel ne peut pas contenir plus de 128 caractères.`,
	PasswordLengthError: `Le mot de passe ne peut pas dépasser 10 caractères.`,
	PasswordMismatch: `Les mots de passe saisis ne correspondent pas.  Veuillez le saisir de nouveau`,
	NameLengthError: `{0} ne peut pas contenir plus de 35 caractères`,
	EmptyNameError: '{0} ne peut être vide.',
	WhatAreMaintenanceSchedules: `Que sont les menus d'entretien?`,
	WhatAreMaintenanceSchedulesText1: `Il s'agit d'ensembles qui comprennent tous les services d'entretien dont vous avez besoin en fonction du kilométrage actuel et de l'âge de votre véhicule.`,
	WhatAreMaintenanceSchedulesText2: `Vous n'avez pas besoin d'ajouter des services individuels dans ces ensembles et chacun répond à vos exigences d'entretien à intervalles réguliers.`,
	PricingDisclaimer: `** La tarification affichée est basée sur les informations disponibles et les sélections d'utilisateurs sur le site.  Le prix final du concessionnaire pourrait différer de celui de l'estimation finale fournie par cet outil.`,
	Item: `article`,
	Items: `articles`,
	ScheduleOption: `Sélectionnez une option de menu d'entretien:`,
	MileageOption: `Le menu d'entretien ci-dessous est basé sur le kilométrage du véhicule:`,
	MenuScheduleDetails: `Détails sélection menu`,
	WhyDoINeedThis: `Pourquoi ai-je besoin de cela?`,
	WhatIsThisFor: `À quoi est-ce que ça sert?`,
	RecommendedVehicle: `Recommandé pour votre véhicule pour les raisons suivantes:`,
	ThisMaintenanceIncludes: `Ce service comprend`,
	PhoneNumber: `Numéro de téléphone *`,
	EmailAddress: `Courriel *`,
	Start: `Début`,
	SchAppt: `Planifier rendez-vous`,
	YourAcct: `Votre compte`,
	CheckRepair: `Vérifier une réparation`,
	LogIn: `Se connecter`,
	MoreDetails: `Plus de détails`,
	ServicePortal: `Portail service`,
	WeOwesHeader: `Nous vous devons`,
	WeOwesDescription: `On dirait que nous vous devons du service.  Sélectionnez ceux que vous souhaitez ajouter à votre rendez-vous.`,
	RecallsHeader: `Rappels`,
	RecallsDescription: `{0} a publié les rappels suivants pour votre véhicule.  Sélectionnez un rappel pour faire savoir à votre conseiller que vous êtes intéressé.  Des rendez-vous supplémentaires pourraient être nécessaires.`,
	RecommendedHeader: `Recommandé`,
	RecommendedDescription: `Nous vous avons recommandé les services suivants lors de votre dernière visite.  Aimeriez-vous sélectionner un conseiller en particulier?`,
	WorkDoneElsewhere: `Vous pouvez également nous faire savoir si vous avez déjà fait faire le travail ailleurs.`,
	SelectWeOwe: `Sélectionnez ceux que vous souhaitez ajouter à votre rendez-vous.`,
	DoneElsewhere: `Ce travail a déjà été fait ailleurs`,
	Excellent: `Excellent!`,
	EnterPhoneEmail: `Veuillez saisir votre e-mail ou votre numéro de téléphone pour localiser facilement votre véhicule et commencer.`,
	LoginPrompt: `Vous avez déjà créé un compte? Vous pouvez vous connecter ici.`,
	OrLiteral: `OU`,
	NoImNew: `Non, je n'ai pas de compte`,
	YesIHave: `Oui`,
	Cancel: `Annuler`,
	Update: `Mettre à jour`,
	EnterEmailPassword: `Entrez votre courriel et votre mot de passe ci-dessous.`,
	ForgotPassword: `Mot de passe oublié?`,
	NoAccount: `Vous n'avez pas de compte?`,
	GladtoSee: `Heureux de vous revoir!`,
	HiUser: `Bonjour {0},`,
	AccountSelect: `Sélectionnez ce que vous souhaitez faire:`,
	ApptRepair: `R-V/réparation`,
	Account: `Compte`,
	ContactUs: `Nous contacter`,
	ViewCurrentRepair: `Afficher réparation(s) en cours`,
	ViewCurrentAppt: `Afficher/modifier le(s) rendez-vous à venir`,
	AddNewAppt: `Ajouter nouveau R-V`,
	NewAppt: `Nouveau rendez-vous`,
	ViewAcctInfo: `Afficher/mettre à jour informations compte`,
	ViewDocuments: `Afficher les documents`,
	ChangePassword: `Changer mot de passe`,
	ViewVehicles: `Afficher/modifier véhicule(s)`,
	CheckMfgRecalls: `Vérifier rappels du fabricant`,
	ViewRecommended: `Afficher service(s) recommandé(s)`,
	ViewRepairHist: `Afficher l'historique de service`,
	AddVehicle: `Ajouter véhicule`,
	ContactDealer: `Contacter le concessionnaire`,
	GladToHaveYou: `Heureux de vous accueillir! Commençons.`,
	WhichVehicle: `Quel véhicule apportez-vous?`,
	FirstVisit: `Première visite?`,
	SelectMake: `Sélectionnez la marque`,
	SelectModel: `Sélectionnez le modèle`,
	SelectOption: `Sélectionnez l'option`,
	SelectEngine: `Sélectionnez le moteur`,
	SelectSpgModel: `Sélectionnez le modèle SPG`,
	SelectTrim: `Sélectionnez la garniture`,
	SelectYear: `Sélectionnez l'année`,
	DisplaySelVeh: `Votre véhicule sélectionné s'affichera ici.`,
	SelVehicle: `Votre véhicule sélectionné:`,
	Miles: `kilomètres`,
	UnknownMileage: `Je ne connais pas mon kilométrage.`,
	VehicleAddBtn: `AJOUTER VÉHICULE`,
	EstimatedMileage: `kilométrage total estimé *`,
	AddServices: `Sélectionnez les services dont votre véhicule a besoin ainsi que l'heure de votre rendez-vous.`,
	AddServiceBtnText: `Ajouter des services`,
	AddIndSvcBtnText: `AJOUTER SERVICE`,
	RemoveSvcBtnText: `RETIRER SERVICE`,
	SkipServices: `Sautez l'ajout de services et sélectionnez votre heure de rendez-vous`,
	SkipServiceBtnText: `Sauter services`,
	SkipServiceReason: `Dites-nous pourquoi vous apportez votre véhicule au service:`,
	QuickTimesAdv: `Voici le conseiller de votre dernière visite et ses prochaines heures de rendez-vous disponibles:`,
	QuickTimesTrans: `Votre transport lors de votre dernière visite était: `,
	QuickTimesTransDefault: `Voici quelques heures de rendez-vous avec transport: `,
	TransAltLit: `J'aimerais utiliser une voiture {0}`,
	ApptSelected: `Heure de rendez-vous sélectionnée!`,
	ServiceAdded: `Service ajouté!`,
	WeFoundYou: `Vous ferez faire l'entretien de quel véhicule avec nous aujourd'hui?`,
	PreviousMileage: ` - kilométrage précédent (en date du {0})`,
	CurrentMileage: ` - kilométrage actuel`,
	AddNewVehicle: `Ajouter un nouveau véhicule`,
	DateTime: `Date et heure`,
	Transportation: `Transport`,
	EnterVin: `Entrez votre NIV`,
	SelectColorMileage: `Entrez votre kilométrage estimé.  `,
	VINunknown: `Je ne connais pas mon NIV.`,
	Red: `Rouge`,
	White: `Blanc`,
	SelectColor: `Sélectionnez la couleur *`,
	VIN: `Numéro d'identification du véhicule (NIV)`,
	Make: `Marque`,
	Year: `Année`,
	Model: `Modèle`,
	Trim: `Garniture`,
	EnterEstimatedMileage: `Entrer kilométrage estimé *`,
	Skip: `Sauter`,
	DiffColor: `Couleur différente`,
	EnterDiffColor: `Entrer couleur différente *`,
	AlmostThere: `On achève!`,
	ReadyToAdd: `Nous sommes prêts à ajouter votre rendez-vous, mais veuillez d'abord entrer votre nom, votre numéro de téléphone et votre courriel:`,
	Advisor: `Conseiller`,
	Write: `Écrire`,
	ManuallyWrite: `Décrivez dans vos propres mots`,
	AddedIssue: `Problème ajouté`,
	YourIssue: `Votre problème est le suivant:`,
	AnyAdditional: `Avez-vous d'autres commentaires?`,
	WalkThroughDiagnose: `Passons en revue le diagnostic de votre problème`,
	Diagnose: `Diagnostiquer`,
	WalkThroughIssue: `Laissez-nous vous expliquer votre problème`,
	PleaseDescribe: `Veuillez décrire votre problème`,
	ConfirmIssue: `Confirmer le problème`,
	AddIssueButton: `Ajouter un problème`,
	AddDiagnosisButton: `Ajouter diagnostic`,
	DiagnoseButton: `Diagnostiquer problème`,
	CancelButton: `Annuler`,
	BackButton: `Reculer`,
	NextButton: `Suivant`,
	DiagnoseHeader: `Diagnostiquer`,
	CallDealerForPricing: `Appeler concessionnaire pour tarification`,
	CustomRange: `Intervalle personnalisée`,
	HereAre: `Voici`,
	Times: `heures pour`,
	With: `avec`,
	ApptDay: `Quel jour aimeriez-vous avoir votre rendez-vous?`,
	TimeFilter: `Limitez les heures d'affichage à une certaine heure de la journée, ou choisissez votre propre intervalle.`,
	AdvisorSelect: `Aimeriez-vous sélectionner un conseiller en particulier?`,
	DifferentTime: `Heure différente`,
	YourAppt: `Votre rendez-vous:`,
	ApptIn: `Rendez-vous dans:`,
	Close: `Fermer`,
	YourApptDate: `Votre date de rendez-vous:`,
	Congratulations: `Félicitations!`,
	ApptWasAdded: `Votre rendez-vous a été ajouté!`,
	ApptWasUpdated: `Votre rendez-vous a été mis à jour!`,
	CommConfirm: `Vous recevrez sous peu un courriel ou un message texte de confirmation.`,
	SaveAppt: `Enregistrer le rendez-vous`,
	CalendarAddLink: `Cliquez sur le lien pour ajouter le rendez-vous à votre calendrier:`,
	Google: `Google`,
	Yahoo: `Yahoo`,
	Outlook: `Outlook`,
	CreateAcctOnConfirm: `Aimeriez-vous créer un compte pour gérer et suivre votre véhicule pendant qu'il est dans l'atelier, ainsi que pour ajouter facilement de futurs rendez-vous?`,
	NoThanks: `Non merci`,
	EnterNewPassword: `; entrez votre nouveau mot de passe ci-dessous`,
	Reset: `Réinitialiser`,
	ResetPass: `Réinitialiser le mot de passe`,
	OperationDetails: `Détails opération`,
	Selected: `Sélectionné:`,
	RetrievingDataFromOEM: `Extraction des données du fabricant...`,
	RecommendedAlert: `Attention immédiate requise`,
	RecommendedWarning: `Attention requise bientôt`,
	InvalidField: `Champ invalide`,
	InquiryError: `Nous ne sommes pas en mesure de vérifier si votre véhicule a fait l'objet d'un rappel pour le moment.  Veuillez communiquer avec le concessionnaire pour voir s'il y a des rappels ouverts pour votre véhicule.`,
	Date: `Date`,
	Time: `Heure : `,
	IncorrectPassword: `Mot de passe incorrect`,
	IncorrectPassMsg: `Désolé, le mot de passe de ce compte est incorrect.  Aimeriez-vous essayer de nouveau ou vous envoyer par courriel un lien pour réinitialiser votre mot de passe? (Le mot de passe est sensible à la casse.)`,
	IncorrectCode: `Code Incorrect`,
	ExpiredCode: `Code Expiré`,
	InvalidCode: `Code invalide`,
	EnterCodeAgain: `Le code de sécurité entré est incorrect. Veuillez saisir à nouveau le code ou envoyer un nouveau code.`,
	SecurityCode: 'Code de sécurité *',
	RequestNewCode: `Le code que vous avez essayé d'entrer a expiré. Veuillez demander un nouveau code d'authentification.`,
	RequestOrContact: `Le code que vous avez essayé d'entrer a expiré. Veuillez demander un nouveau code d'authentification.`,
	TryAgain: `Essayez de nouveau`,
	NoAccountFound: `Aucun compte trouvé`,
	NoAccFoundMsg: `Désolé, nous n'avons pas pu trouver de compte lié à {0}. Voulez-vous réessayer ou ouvrir un nouveau compte?`,
	AddYourOwnIndService: `Ajouter votre propre service?`,
	AddYourOwnIndServiceDetails: `Vous ne voyez pas ce que vous cherchez ci-dessous?  Vous pouvez ajouter votre propre service en utilisant notre outil de diagnostic ou en l'inscrivant manuellement.  Cliquez sur le lien ci-dessous pour y accéder maintenant.`,
	AddYourOwnIndServiceLink: `Accéder à Inscrivez vos propres services`,
	Continue: `Continuer`,
	CustSearchErrorMessage: `Désolé, nous n'avons pas pu trouver votre enregistrement en utilisant {0}. Voulez-vous modifier ces informations et réessayer ou continuer à ajouter votre rendez-vous en tant que nouveau client?`,
	CompanyAccFound: `Désolé, nous ne pouvons pas accéder aux véhicules pour l'enregistrement en utilisant {0} pour le moment. Veuillez appeler {1} pour prendre rendez-vous ou continuer à ajouter votre rendez-vous en tant que nouveau client.`,
	NoVehAccess: `Pas d'accès aux véhicules`,
	RecommendedLastVisit: `Recommandé lors de la dernière visite`,
	WhatAreRecalls: `Un rappel est émis lorsqu'un fabricant ou la Transports Canada détermine qu'un véhicule, de l'équipement, un siège de véhicule ou un pneu pose un risque déraisonnable pour la sécurité ou ne respecte pas les normes de sécurité minimales.La plupart des décisions d'effectuer un rappel et de remédier à un défaut lié à la sécurité sont prises volontairement par les fabricants avant que la Transports Canada n'intervienne. `,
	No: `Non`,
	Yes: `Oui`,
	DetailsNotAvailable: `Les détails ne sont pas disponibles pour ce service.  Veuillez contacter le concessionnaire pour plus d'informations.`,
	SelectYourVeh: `Sélectionnez votre véhicule`,
	AccessibilityPanel: `Panneau de configuration d'accessibilité`,
	AccessibilityHeader: `Sélectionnez l'option suivante pour modifier l'apparence du site afin de mieux répondre à vos besoins:`,
	ColorSensitive: `Activer apparence active sensible à la couleur`,
	UpdateSite: `Mise à jour du site`,
	RequiredFields: `Les champs obligatoires sont marqués d'un astérisque *.`,
	SchApptTitle: `Cliquez pour fixer un rendez-vous de service`,
	YourAcctTitle: `Cliquez pour afficher votre compte de propriétaire en ligne`,
	CheckRepairTitle: `Cliquez pour afficher l'état de vos réparations de service en temps réel`,
	MenuTitle: `Cliquez pour accéder au menu de navigation du site`,
	BackTitle: `Cliquez pour revenir à la page précédente`,
	ProfileTitle: `Cliquez pour afficher et mettre à jour vos renseignements`,
	LogInTitle: `Cliquez pour vous connecter à votre compte en ligne`,
	UpdateTitle: `Cliquez pour enregistrer vos modifications`,
	Services: `Services`,
	MinEstCost: `Coût minimum estimé: $`,
	ReadDisclaimer: `J'ai lu l'avis de non-responsabilité complet`,
	ContactEmail: `Courriel`,
	ContactTextMessage: `Texte`,
	ContactBoth: `Les deux`,
	NoCapital: `NON`,
	YesCapital: `OUI`,
	Confirmation: `Confirmation`,
	SendConfirmation: `Envoyez votre confirmation de rendez-vous à: *`,
	MakePreferred: `Souhaitez-vous en faire votre mode de communication préféré?`,
	TextOptIn: `Consentement textos`,
	OptIn1: `En sélectionnant "Oui", vous consentez expressément par écrit à recevoir des messages texte automatisés de `,
	OptIn2: `. Vous pouvez retirer votre consentement en tout temps en répondant FIN à `,
	OptIn3: ` ou en communicant avec `,
	OptIn4: ` à `,
	OptIn5: `. Non requis pour l'achat. Des frais standard pour les messages et les données peuvent s'appliquer.`,
	OptIn6: 'Messaging Privacy Policy/Terms of Service.',
	Appointment: `Rendez-vous`,
	ServiceAppt: `#NOM?`,
	Dealership: `Concessionnaire`,
	Photo: `Photo`,
	Image: `Image`,
	HereProfile: `Voici ce que nous avons dans votre dossier`,
	StreetAddress: `Adresse *`,
	City: `Ville *`,
	State: `Province *`,
	ZipCode: `Code postal *`,
	OptedIn: `Autorisé`,
	ChangeInfo: `Modifier les informations`,
	LetsReviewAdd: `Examinons vos options une dernière fois avant d'ajouter votre rendez-vous:`,
	LetsReviewModify: `Examinons vos options une dernière fois avant de modifier le rendez-vous:`,
	Monday: `Lundi`,
	Tuesday: `Mardi`,
	Wednesday: `Mercredi`,
	Thursday: `Jeudi`,
	Friday: `Vendredi`,
	Saturday: `Samedi`,
	Sunday: `Dimanche`,
	ext: `ext`,
	PhoneHeader: `Numéro de téléphone`,
	EmailHeader: `Courriel`,
	AddressHeader: `Adresse`,
	Hours: `Heures d'ouverture`,
	AdditionalInfo: `Renseignements supplémentaires`,
	Service: `Service`,
	Express: `Express`,
	BdyShop: `Carrosserie`,
	Contact: `Contact`,
	WhichDept: `Quel département souhaitez-vous contacter?`,
	AddApptMsg1: `Vous n'avez aucun rendez-vous planifié actuellement. Vous voulez ajouter un rendez-vous? Cliquez sur le bouton ci-dessous.`,
	AddApptMsg2: `Vous avez un rendez-vous planifié actuellement. Vous voulez ajouter un autre rendez-vous? Cliquez sur le bouton ci-dessous.`,
	AddCustVehMsg: `Veuillez entrer le NIV.`,
	UpcomingAppt: `Rendez- vous à venir`,
	EditAppt: `Modifier RV`,
	In: `po`,
	PrevRecommSvc: `Ce sont des services que nous avons recommandés lors de votre dernière visite.`,
	SelPrevRecomm: `Sélectionnez ceux que vous souhaitez ajouter à un rendez-vous.`,
	PrevRecomm: `Recommandé précédemment`,
	outStandingRcl: `Rappels en suspens`,
	zeroNumb: `0`,
	NoOustanding: `Il n'y a actuellement aucun rappel en suspens pour vos `,
	PullingRecalls: `Nous sommes en train de rechercher vos rappels. Veuillez patienter...`,
	ManuRecalls: `Rappels du fabricant`,
	InitiatedRcl: `a lancé les rappels suivants sur votre`,
	AddToAppt: `Sélectionnez une option à ajouter à un rendez-vous.`,
	CheckRcl: `Cliquez sur le bouton ci-dessous pour vérifier si votre véhicule a fait l'objet d'un rappel par le manufacturier.`,
	VinDecodeError: `Erreur de décodage du NIV`,
	VinDecodeMsg: `Désolé, nous n'avons pas pu décoder votre NIV.  Veuillez essayer à nouveau.`,
	VinOwnedMsg: `Désolé, ce NIV appartient déjà à un client.`,
	ROHistory: `Historique réparation`,
	ROHistoryMsg: `Cliquez sur le numéro de réparation pour afficher plus de détails.  Si vous souhaitez sauvegarder ou imprimer l'un de ces documents, `,
	ClickHere: `cliquez ici.`,
	Repair: `Réparation`,
	Price: `Prix`,
	Description: `Description`,
	NoTimeAdvAvailLit: `Votre dernier conseiller n'a pas d'intervalle horaire disponible pour les rendez-vous.  Veuillez sélectionner Heure différente ci-dessous pour changer de conseiller.`,
	NoTimeTransAvailLit: `Votre dernier type de transport n'a pas d'intervalle horaire disponible pour les rendez-vous.  Veuillez sélectionner Heure différente ci-dessous afin de modifier les types de transport.`,
	WhichVeh: `Quel véhicule aimeriez-vous voir ou modifier?`,
	ClickResetPass: `Cliquez sur le bouton Réinitialiser le mot de passe ci-dessous pour modifier votre mot de passe.`,
	ResetPassEmailSent: `Un courriel de réinitialisation de votre mot de passe a été envoyé à {0}. Veuillez cliquer sur le lien dans votre courriel pour compléter la modification de votre mot de passe.`,
	RepairDetails: `Détails des réparations`,
	SavePrintInvoice: `SAUVEGARDER/IMPRIMER FACTURE`,
	Concern: `Problème`,
	Cause: `Cause`,
	Correction: `Correction`,
	Previous: `<< Précédent`,
	More: `Suivant >>`,
	Operations: `Opérations`,
	InvoiceTotal: `Total de la facture`,
	PrintSave: `Imprimer/sauvegarder`,
	InvoicedOn: `Facturé le`,
	ROOpenedOn: `Bon de travail ouvert le`,
	RO: `BT#`,
	DecodeVin: `Décoder le NIV`,
	AppointmentError: `Erreur:`,
	WhatsHappening: `Voici ce qui se passe avec votre`,
	NoServices: `Vous n'avez pas encore sélectionné de services. Veuillez sélectionner un service pour continuer.`,
	MyCart: `Mon panier`,
	Pdi: `PDI`,
	ServicesOn: `Services au rendez-vous`,
	VinCreateError: `Erreur d'ajout de véhicule`,
	VinCreateErrorOwned: `Ce véhicule appartient déjà à un autre client. Veuillez entrer un nouveau NIV.`,
	VehicleAddError: `Nous avons de la difficulté à ajouter votre véhicule en ce moment. Assurez-vous que le NIV est saisi correctement.`,
	Closed: `Fermé(e)`,
	MultApptSch: `Plusieurs rendez-vous sont prévus.`,
	ApptSelInfo: `Cliquez sur le rendez-vous pour afficher plus de détails.`,
	ApptNumber: `R-V. Numéro`,
	NoRecalls: `Aucun rappel n'a été trouvé pour votre véhicule.`,
	Logout: `Déconnexion`,
	vehWhichRecall: `Pour quel véhicule aimeriez-vous rechercher les rappels des fabricants?`,
	vehWhichRecom: `Pour quel véhicule aimeriez-vous rechercher les services recommandés précédemment par le fabricant?`,
	vehWhichHistory: `Pour quel véhicule aimeriez-vous consulter l'historique des réparations?`,
	VehNoRepair: `Il n'y a pas d'historique de réparation pour ce véhicule.`,
	VehNoPrev: `Il n'y a pas d'historique de services recommandés pour ce véhicule.`,
	MoreDtls: `Plus de détails`,
	LessDtls: `Moins de détails`,
	LoginTip: `Cliquez pour vous connecter à votre compte en ligne`,
	AddSvcTip: `Cliquez pour ajouter ce service à votre panier`,
	AddSvcsTip: `Cliquez pour ajouter d'autres services à votre rendez-vous`,
	ProceedTip: `Cliquez pour passer à l'étape suivante`,
	Select: `Cliquez pour sélectionner`,
	NoAdvisorTip: `Cliquez pour continuer sans préférences pour un conseiller en particulier pour votre rendez-vous`,
	ChooseAdvisorTip: `Cliquez pour sélectionner ce conseiller pour votre rendez-vous`,
	ImNewTip: `Cliquez pour continuer en tant que nouveau client`,
	AltTimeTip: `Cliquez pour choisir un autre moment pour votre rendez-vous`,
	ExistingCustTip: `Cliquez pour continuer en tant que client concessionnaire existant`,
	SkipServcTip: `Cliquez pour sauter l'ajout de services et choisir l'heure de votre rendez-vous.`,
	SkipRecSvcsTip: `Cliquez pour sauter l'ajout des services recommandés et passer à la sélection d'autres services.`,
	CreateAcctTip: `Cliquez pour créer un compte de propriétaire en ligne`,
	UpdateApptTip: `Cliquez pour voir la date, l'heure, le conseiller et le moyen de transport pour votre rendez-vous.`,
	UpdateVehTip: `Cliquez pour voir votre véhicule de rendez-vous.`,
	SelectDateTip: `Cliquez pour choisir la date de votre rendez-vous`,
	SavePrintTip: `Enregistrer ou imprimer ce document`,
	RecomMaintTip: `Cliquez pour afficher l'entretien recommandé de votre véhicule`,
	ViewServcTip: `Cliquez pour afficher la liste des services de véhicules que nous offrons`,
	WriteYourOwnTip: `Cliquez pour saisir vos besoins particuliers en matière de service ou pour auto-diagnostiquer votre véhicule.`,
	ChangeApptTip: `Apportez des modifications à votre rendez-vous`,
	ManuRecallTip: `Cliquez pour vérifier les rappels ouverts du fabricant pour votre véhicule`,
	SelfDiagnoseTip: `Cliquez pour ajouter votre problème d'auto-diagnostiqué à votre rendez-vous`,
	AddCustomTip: `Cliquez pour ajouter votre problème personnalisé à votre rendez-vous`,
	SkipSvcsTip: `Cliquez pour sauter l'ajout de services et sélectionner une heure de rendez-vous`,
	CurrentRepair: `Réparation en cours`,
	HereCurrentStatus: `Voici l'état actuel de votre `,
	BeingWorkedOn: ` en cours de travail.`,
	StatusFinished: `Terminé`,
	StatusInProgress: `En cours`,
	YourVehicleCurrentlyStep: `Votre véhicule est actuellement à l'étape `,
	Of: ` sur `,
	YourVehicleCurrently: `L'état de votre véhicule est: `,
	Status: `Statut: `,
	RepairOrderNum: `Numéro du bon de travail `,
	VehicleStatus: `Statut de véhicule`,
	Dollar: `$ `,
	InvoiceReady: `Facture prête à payer`,
	BillReady: `, votre facture est prête à être payée en ligne.`,
	PayNow: `Payer maintenant`,
	InvoicePaid: `Facture payée`,
	PaymentReceived: `, votre paiement en ligne a été reçu.`,
	ViewInvoice: `Afficher facture`,
	YourAdvisor: `Votre conseiller`,
	WeFound: `, nous avons trouvé, pendant l'inspection `,
	ItemInspectionAttention: ' élément lors de votre inspection qui nécessite votre attention.',
	ItemsInspectionAttention: `  éléments nécessitant votre attention.`,
	Approved: ` Approuvé `,
	Declined: ` Refusé`,
	ItemsDuringInspection: ` articles pendant votre inspection. Des mesures ont été prises à leur égard.`,
	InspectionResults: `Résultats de l'inspection`,
	ViewResults: `Afficher les résultats ici.`,
	Complete: `Complété`,
	AccountExists: `Le compte existe`,
	MultipleRepairs: `Vous avez actuellement plusieurs réparations en cours.`,
	NoRepairs: `Vous n'avez actuellement aucune réparation ouverte.`,
	RepairDate: `Date réparation`,
	RepairNumber: `Numéro réparation`,
	NoTimes: `Aucune heure disponible n'a été trouvée pour la date et le conseiller sélectionnés Veuillez choisir une date ou un conseiller différent.`,
	NoTimesInTimeRange: `Il n'y a pas de temps pour l'intervalle horaire sélectionnée. Veuillez choisir un intervalle ou un jour différent.`,
	NoTimesForServices: `Aucune heure disponible n'a été trouvée pour les services sélectionnés`,
	UpTo: `Jusqu'à`,
	StartingAt: `À partir de`,
	SignedIn: `Connecté`,
	VinHandy: `Connaissez-vous votre NIV? Entrez-le ci-dessous.`,
	UpcomingClosures: `Fermetures à venir`,
	ConfirmationViewAccount: `Aimeriez-vous accéder à votre compte?`,
	ViewAccount: `Afficher le compte`,
	LogOff: `Déconnexion`,
	Confirm: `Confirmer`,
	WhichVehicleAddingAppt: `Pour quel véhicule ajoutez-vous ce rendez-vous?`,
	ViewAcctOptBackIn1: `Vous avez déjà choisi de ne pas recevoir de textos de notre part. Pour recevoir de nouveau des textos de notre part, vous devrez envoyer un OUI à `,
	ViewAcctOptBackIn2: `. Une fois que vous avez terminé cette étape, revenez ici et sélectionnez OK pour laisser le système vérifier votre statut de consentement.`,
	ViewAcctOptBackInFail: `Nous n'avons pas reçu votre message de consentement. Pour recevoir de nouveau des messages texte de notre part, vous devrez envoyer un OUI à `,
	ViewAcctOptBackInFail2: `. Si vous ne souhaitez pas consentir, sélectionnez Annuler et passez au courriel comme mode de communication préféré.`,
	Okay: `OK`,
	InvalidTokenError: `URL du portail de services non valide. Assurez-vous que l'URL a le jeton correct.`,
	ExpiredTokenError: `L'URL utilisé pour accéder au Portail du service est expiré`,
	ModifyAppointment: `Re-planifier un rendez-vous`,
	UpdateServices: `Mettre à jour les services demandés`,
	UpdateVehicle: `Mettre à jour les renseignements sur le véhicule`,
	ResetPasswordContactDeal: `Nous ne sommes pas en mesure de réinitialiser votre mot de passe pour le moment. Veuillez communiquer avec le concessionnaire pour obtenir un nouveau mot de passe.`,
	PleaseEnterEmail: `Veuillez saisir votre courriel ci-dessus.`,
	EmailSent: `Courriel envoyé`,
	Missed: `Manqué`,
	PleaseSelectService: `Veuillez sélectionner un service pour continuer.`,
	ReasonForVisit: `Raison de la visite`,
	ServiceDocsGreeting: `Voici les documents pour votre {0} suite à votre visite de service le:`,
	ServiceDocsDefaultTitle: `Afficher les documents du service`,
	ServiceDocsNotAvail: `Les documents de cette visite de service ne sont pas disponibles. Veuillez communiquer avec le concessionnaire au {0} si vous avez des questions au sujet de cette visite.`,
	UpdatedColon: `Mise à jour: `,
	PendingRecommendations: `Votre véhicule a {0} réparations recommandées!`,
	ExclamationPoint: `!`,
	CriticalRecommendations: `Votre véhicule a {0} réparations recommandées!`,
	Click: `Cliquez`,
	Here: `ici`,
	ViewInspectionResults: ` pour afficher vos résultats d'inspection.`,
	OpenRepairOrderMessage: `Des documents supplémentaires peuvent être ajoutés. Veuillez revenir pour les mises à jour.`,
	TimerDays: `jours`,
	TimerDay: `jour`,
	TimerHours: `heures`,
	TimerHour: `heure`,
	TimerMinute: `minute`,
	TimerMinutes: `minutes`,
	And: `et`,
	VinExistsMsg: `Vous possédez déjà ce véhicule.  Aimeriez-vous l'afficher?`,
	VinExistsApptMsg: `Vous possédez déjà ce véhicule. Souhaitez-vous prendre rendez-vous pour cela?`,
	EmailUsed: `Courriel utilisé`,
	EmailUsedMsg: `Un compte existe déjà pour {0}. Veuillez entrer une adresse courriel valide. Vos autres mises à jour seront enregistrées.`,
	EmailUsedMsgNoSave: `Un compte existe déjà pour {0}. Veuillez entrer une adresse courriel valide.`,
	LosingVehicle: `Véhicule perdu`,
	LoseAddedVehicleWarning: `Si le rendez-vous n'est pas terminé, votre nouveau véhicule ne sera pas ajouté au garage. Voulez-vous continuer à annuler?`,
	CurrentStatus: `Statut actuel`,
	RecallOp: `RECALL: `,
	TroubleLit: `Nous avons de la difficulté `,
	MessageAdding: `à ajouter`,
	MessageUpdating: `à mettre à jour`,
	ApptTimeLit: ` votre rendez-vous en cours.  Veuillez réessayer dans quelques minutes.`,
	IssuContLit: ` Si le problème persiste, veuillez communiquer avec nous au `,
	OurSpecialServices: `Nos services spéciaux:`,
	Oops: `Oups! Une erreur a survenu.`,
	NetworkError: `Nous ne sommes pas en mesure d'accéder au Portail du service pour le moment. Veuillez réessayer dans quelques minutes.`,
	AcctTimeLit: ` les renseignements sur votre compte en ce moment.  Veuillez réessayer dans quelques minutes.`,
	CancelAppt: `Annuler rendez-vous`,
	AreYouSure: `Êtes-vous certain de vouloir annuler votre rendez-vous?`,
	GoBack: `Retour`,
	AddAppt: `Ajouter rendez-vous`,
	ThankYou: `Merci!`,
	ApptCanceled: `Votre rendez-vous a été annulé.`,
	CreateNewAppt: `Voulez-vous créer un nouveau rendez-vous?`,
	UpdateInfo: `Mise à jour des informations`,
	Save: `Sauvegarder`,
	ClickToUpdate: `Cliquez pour mettre à jour vos renseignements`,
	ClickToSave: `Cliquez pour enregistrer vos modifications`,
	Warranty: `Garantie`,
	DropOff: `Déposer le véhicule avant `,
	BeforeLit: `Avant `,
	ApptUnavailable: `Rendez-vous non disponible`,
	SelectNewAdv: `Le conseiller, la date ou l'heure que vous avez sélectionné initialement n'est plus disponible. Veuillez modifier le conseiller, la date ou l'heure.`,
	PhoneUnavailableMsg: `Ce numéro de téléphone ne peut pas être utilisé pour les rendez-vous. Veuillez entrer un autre numéro de téléphone et réessayer.`,
	HereApptAdv: `Voici quelques heures de rendez-vous pour le conseiller:`,
	Cancelling: `annulation`,
	OkLit: `OK`,
	ACSTooltip: `Cliquez pour ouvrir le panneau de configuration d'accessibilité`,
	CartTooltip: `Cliquez pour accéder aux services demandés`,
	SelectTheYear: `Sélectionnez l'année`,
	Other: `Autre`,
	CheckRecalls: `Vérifier les rappels`,
	Unknown: `Inconnu`,
	RememberDevice: `Retenir cet appareil`,
	ConfirmUpdates: `Confirmer les mises à jour`,
	NoServicesSelected: `Aucun service n'est sélectionné pour vous.  Veuillez`,
	NoServicesClickHere: `cliquer ici`,
	ToSelectAService: `pour sélectionner un service.`,

	Unassigned: `Non assigné`,
	PicsVideos: `Photos et vidéos`,
	SelectThumbnail: `Sélectionnez une miniature pour afficher une image agrandie et des informations supplémentaires`,
	DownloadSelected: `Télécharger sélection`,
	LastServiced: `Dernier service`,
	MenuViewInspectionResults: `Afficher les résultats de l'inspection`,
	CheckRepairStatus: `Vérifier statut de réparation du service`,
	ScheduleService: `Planifier entretien`,
	ViewVehicleServiceHistory: `Afficher l'historique de service du véhicule`,
	YourModelsHistory: `Historique de service de votre {0}`,
	ViewHistoryPrepOn: `Préparé le {0} pour :`,
	Comments: `Commentaires`,
	Recommendations: `Recommandations`,
	RepairOrder: `Bon de travail`,
	Odometer: `Odomètre`,
	Job: `Activité`,
	Technicians: `Technicien(s)`,
	WarrClaimNum: `#Réclamation sous garantie`,
	WarrOperation: `Opération sous garantie`,
	Customer: `Client`,
	Internal: `Interne`,
	Complaint: `Plainte`,
	CampaignNum: `#Campagne`,
	RNDDEFull: `Recommandé non fait/Fait ailleurs/Refusé`,
	Campaign: `Campagne`,
	Phone: `Téléphone`,
	VINAcronym: 'NIV',
	Notes: 'Remarques',
	CodeSent: 'Code envoyé!',
	IdentityVerification: `Vérification D'identité`,
	SecurityString1: `La sécurité de vos informations personnelles est importante pour nous. `,
	SecurityString2: `Veuillez vérifier votre identité à l'aide d'un code de sécurité pour vous connecter à votre compte.`,
	SecurityString3: `Veuillez vérifier votre identité à l'aide d'un code de sécurité pour afficher ou modifier vos informations personnelles.`,
	SecurityString4: `Veuillez vérifier votre identité à l'aide d'un code de sécurité pour afficher les documents d'entretien de votre véhicule.`,
	SelectAuthMethod: `Veuillez sélectionner un numéro de téléphone ou une adresse e-mail pour recevoir un code de sécurité: `,
	MaxAttemptsExceeded: `Le nombre maximum de tentatives a été dépassé. Veuillez demander un nouveau code d'authentification.`,
	Verify: `Vérifier`,
	CodeError: `Le code de sécurité doit être composé de 6 chiffres`,

	UpdateMileage: `Veuillez mettre à jour le kilométrage de votre véhicule.`,
	UpdateMilStart: `Votre kilométrage précédent était `,
	UpdateMilMid: ` kilomètres. `,
	UpdateMilEnd: `Veuillez entrer un kilométrage estimé. `,
	UpdateMilLess: `Le kilométrage entré doit être supérieur ou égal à votre kilométrage précédent.`,
	Choose: 'Choisir',
	SaveAs: 'Enregistrer sous',
	ClickHereMoreDtl: 'Cliquez ici pour plus de détails.',

	// WriteYourOwn Dialog Literals
	WhichApplies: `Lequel des énoncés suivants s'applique?`,
	IFeelIt: `Je le sens (hésitation, vibration, etc.)`,
	Feel: `Sensation`,
	IFeel: `Je sens...`,
	VehicleDrift: `Le véhicule dérive ou tire sur un côté`,
	VehicleDriftTo: `Je sens que le véhicule dérive ou tire vers la...`,
	Left: `Gauche`,
	VehicleDriftToLeft: `Je sens le véhicule dérive ou tire vers la gauche.`,
	Right: `Droite`,
	VehicleDriftToRight: `Je sens le véhicule dérive ou tire vers la droite.`,
	PlaySteeringWheel: `Jeu excessif dans le volant`,
	FeelPlaySteeringWheel: `Je sens un jeu excessif ou un relâchement dans le volant.`,
	PulsingVibrations: `Pulsations ou vibrations`,
	FeelPulsingVibrations: `Je sens des pulsations ou des vibrations venant de...`,
	FrontVehicle: `Avant du véhicule`,
	PulsingVibrationsFront: `Je sens des pulsations ou des vibrations venant de l'avant du véhicule...`,
	WhenAccelerating: `Lors de l'accélération`,
	PulsingVibrationsFrontAccelerating: `Je sens des pulsations ou des vibrations venant de l'avant du véhicule lors de l'accélération.`,
	RearVehicle: `L'arrière du véhicule`,
	PulsingVibrationsRear: `Je sens des pulsations ou des vibrations venant de l'arrière du véhicule...`,
	PulsingVibrationsRearAccelerating: `Je ressens des pulsations ou des vibrations provenant de l'arrière du véhicule lors de l'accélération.`,
	WhenBraking: `Lors du freinage`,
	PulsingVibrationsFrontBraking: `Je ressens des pulsations ou des vibrations provenant de l'avant du véhicule lors du freinage.`,
	PulsingVibrationsRearBraking: `Je sens des pulsations ou des vibrations venant de l'arrière du véhicule lorsque je freine.`,
	HigherSpeeds: `À des vitesses plus élevées`,
	PulsingVibrationsFrontHigh: `Je ressens des pulsations ou des vibrations provenant de l'avant du véhicule lorsque je roule à grande vitesse.`,
	PulsingVibrationsRearHigh: `Je sens des pulsations ou des vibrations venant de l'arrière du véhicule lorsque je conduis à des vitesses plus élevées.`,
	AllTheTime: `Tout le temps`,
	PulsingVibrationsFrontAll: `Je ressens constamment des pulsations ou des vibrations provenant de l'avant du véhicule.`,
	PulsingVibrationsRearAll: `Je sens constamment des pulsations ou des vibrations venant de l'arrière du véhicule.`,
	PulsingVibrationsFrontNone: `Je ressens des pulsations ou des vibrations provenant de l'avant du véhicule.`,
	None: `Aucun de ces choix`,
	PulsingVibrationsRearNone: `Je sens des pulsations ou des vibrations venant de l'arrière du véhicule.`,
	SteeringWheel: `Le volant`,
	PulsingVibrationsSteeringWheel: `Je sens des pulsations ou des vibrations venant du volant.`,
	PulsingVibrationsSteeringWheelAccelerating: `Je sens des pulsations ou des vibrations venant du volant lorsque j'accélère.`,
	PulsingVibrationsSteeringWheelBraking: `Je sens des pulsations ou des vibrations provenant du volant lorsque je freine.`,
	WhenTurning: `Lorsque je tourne`,
	PulsingVibratingSteeringWheelTurning: `Je sens des pulsations ou des vibrations venant du volant lorsque je tourne.`,
	PulsingVibratingSteeringWheelSpeeds: `Je sens des pulsations ou des vibrations provenant du volant lorsque je conduis à des vitesses plus élevées.`,
	PulsingVibratingSteeringWheelAll: `Je sens constamment des pulsations ou des vibrations venant du volant.`,
	PulsingVibrationsSteeringWheelNone: `Je sens des pulsations ou des vibrations venant du volant.`,
	PulsingVibrationsVehicle: `Je sens des pulsations ou des vibrations venant de mon véhicule.`,
	Swaying: `L'oscillation du véhicule`,
	SwayingSideToSide: `Je sens le véhicule se balancer d'un côté à l'autre.`,
	FeelsDifferent: `Le véhicule n'est pas comme d'habitude.`,
	IHearIt: `Je l'entends (cliquetis, cognement, grincement, etc.)`,
	Hear: `Écoutez`,
	IHear: `J'entends...`,
	SquealingChirping: `Grincement ou couinement`,
	SquealingChirpingFrom: `J'entends un crissement ou un sifflement venant de...`,
	TheEngine: `Le compartiment moteur`,
	SquealingChirpingEngine: `J'entends un sifflement venant du compartiment moteur...`,
	SquealingChirpingEngineAll: `J'entends constamment un sifflement provenant du compartiment moteur.`,
	WhenStopping: `Lors de l'arrêt`,
	SquealingChirpingEngineStopping: `J'entends un sifflement provenant du compartiment moteur lorsque je m'arrête.`,
	OnlyWhenStarting: `Seulement au démarrage du véhicule`,
	SquealingChirpingEngineStarting: `J'entends un sifflement provenant du compartiment moteur seulement lorsque je démarre le véhicule.`,
	OnlyWhenTurning: `Seulement pour faire tourner le véhicule`,
	SquealingChirpingEngineTurning: `J'entends un sifflement provenant du compartiment moteur seulement lorsque je fais tourner le véhicule.`,
	OnlyWhileMoving: `Seulement lorsque le véhicule est en mouvement`,
	SquealingChirpingEngineMoving: `J'entends un sifflement provenant du compartiment moteur seulement lorsque le véhicule est en mouvement.`,
	SquealingChirpingEngineNone: `J'entends un sifflement venant du compartiment moteur.`,
	Interior: `L'intérieur du véhicule`,
	SquealingChirpingInterior: `J'entends un sifflement venant de l'intérieur du véhicule...`,
	SquealingChirpingInteriorAll: `J'entends constamment un grincement ou un sifflement venant de l'intérieur du véhicule.`,
	HeatOrAC: `Seulement lorsque le chauffage ou le climatiseur est activé`,
	SquealingChirpingInteriorHeatAC: `J'entends un crissement ou un sifflement provenant de l'intérieur du véhicule lorsque le chauffage ou le climatiseur est allumé.`,
	SquealingChirpingInteriorNone: `J'entends un crissement ou un sifflement venant de l'intérieur du véhicule.`,
	Under: `Sous le véhicule`,
	SquealingChirpingUnder: `J'entends un crissement ou un sifflement venant d'en dessous du véhicule`,
	SquealingChirpingUnderAll: `J'entends un crissement ou un sifflement constant venant d'en dessous du véhicule`,
	SquealingChirpingUnderStopping: `J'entends un crissement ou un sifflement venant d'en dessous du véhicule à l'arrêt.`,
	SquealingChirpingUnderTurning: `J'entends un crissement ou un sifflement venant d'en dessous du véhicule lorsque je tourne.`,
	SquealingChirpingUnderMoving: `J'entends un crissement ou un sifflement venant d'en dessous du véhicule seulement en mouvement.`,
	SquealingChirpingUnderNone: `J'entends un crissement ou un sifflement venant d'en dessous du véhicule.`,
	Hissing: `Sifflement`,
	HearHissing: `J'entends un crissement ou un sifflement provenant de...`,
	HissingEngine: `J'entends un sifflement provenant du compartiment moteur.`,
	HissingEngineAll: `J'entends constamment un sifflement constant provenant de l'intérieur du véhicule.`,
	HissingEngineStarting: `J'entends un sifflement provenant du compartiment moteur au démarrage du véhicule.`,
	HissingEngineMoving: `J'entends un sifflement provenant du compartiment moteur seulement pendant que le véhicule est en mouvement.`,
	HissingEngineNone: `J'entends un sifflement venant du compartiment moteur.`,
	HissingInterior: `J'entends un sifflement venant de l'intérieur du véhicule...`,
	HissingInteriorAll: `J'entends constamment un sifflement venant de l'intérieur du véhicule.`,
	HissingInteriorHeatAC: `J'entends un sifflement de l'intérieur du véhicule seulement lorsque le chauffage ou le climatiseur est activé.`,
	HissingInteriorNone: `J'entends un sifflement venant de l'intérieur du véhicule.`,
	FromTire: `Du pneu`,
	HissingTire: `J'entends un sifflement venant du pneu sur...`,
	DriversSideFront: `Le côté conducteur à l'avant du véhicule`,
	HissingTireDriversSideFront: `J'entends un sifflement provenant du pneu du côté du conducteur à l'avant du véhicule.`,
	DriversSideRear: `Le côté conducteur arrière du véhicule`,
	HissingTireDriversSideRear: `J'entends un sifflement provenant du pneu du côté conducteur à l'arrière du véhicule.`,
	PassengersSideFront: `Le côté passager à l'avant du véhicule`,
	HissingTirePassengersSideFront: `J'entends un sifflement provenant du pneu du côté du passager à l'avant du véhicule.`,
	PassengersSideRear: `Le côté passager arrière du véhicule`,
	HissingTirePassengersSideRear: `J'entends un sifflement provenant du pneu du côté passager à l'arrière du véhicule.`,
	OtherTire: `Autre (pneu de secours, etc.)`,
	HissingOtherTire: `J'entends un sifflement provenant du pneu.`,
	HissingNone: `J'entends un sifflement.`,
	Knocking: `Cognement`,
	HearKnocking: `J'entends un cognement.`,
	HearKnockingAll: `J'entends un cognement constant.`,
	KnockingStarting: `J'entends un cognement lors du démarrage du véhicule.`,
	KnockingNone: `J'entends un cognement.`,
	Tapping: `Tapage`,
	HearTapping: `J'entends un tapage provenant de...`,
	TappingEngine: `J'entends un tapage provenant du compartiment moteur...`,
	TappingEngineAll: `J'entends constamment un tapage provenant compartiment moteur.`,
	TappingEngineStarting: `J'entends un tapage provenant du compartiment moteur au démarrage du véhicule.`,
	TappingEngineMoving: `J'entends un tapage provenant du compartiment moteur seulement pendant que le véhicule est en mouvement.`,
	TappingEngineNone: `J'entends un tapage provenant du compartiment moteur.`,
	TappingUnder: `J'entends un tapage provenant d'en dessous du véhicule...`,
	TappingUnderAll: `J'entends un tapage constant provenant d'en dessous du véhicule`,
	TappingUnderStarting: `J'entends un tapage provenant d'en dessous de véhicule au démarrage du véhicule.`,
	TappingUnderMoving: `J'entends un tapage provenant d'en dessous du véhicule seulement en mouvement.`,
	TappingUnderNone: `J'entends un tapage provenant d'en dessous du véhicule.`,
	TappingNone: `J'entends un tapage.`,
	Rattle: `Un cliquetis`,
	HearRattle: `J'entends un cliquetis venant du...`,
	RattleEngine: `J'entends un cliquetis venant du compartiment moteur.`,
	RattleEngineAll: `J'entends un cliquetis constant venant du compartiment moteur.`,
	RattleEngineStarting: `J'entends un cliquetis venant du compartiment moteur au démarrage du véhicule.`,
	RattleEngineMoving: `J'entends un cliquetis qui vient du compartiment moteur seulement lorsque le véhicule est en mouvement.`,
	RattleEngineNone: `J'entends un cliquetis provenant du compartiment moteur.`,
	RattleUnder: `J'entends un cliquetis provenant d'en dessous du véhicule.`,
	RattleInterior: `J'entends un cliquetis provenant de l'intérieur du véhicule.`,
	RattleInteriorAll: `J'entends constamment un cliquetis provenant de l'intérieur du véhicule.`,
	RattleInteriorHeatAC: `J'entends un cliquetis de l'intérieur du véhicule seulement lorsque le chauffage ou le climatiseur est activé.`,
	RattleInteriorNone: `J'entends un cliquetis provenant de l'intérieur du véhicule.`,
	RattleNone: `J'entends un cliquetis.`,
	Grinding: `Frottement`,
	HearGrinding: `J'entends un frottement provenant du...`,
	GrindingEngine: `J'entends un frottement provenant du compartiment moteur.`,
	GrindingEngineAll: `J'entends un frottement constant provenant du compartiment moteur.`,
	GrindingEngineStopping: `J'entends un frottement provenant du compartiment moteur seulement lorsque je m'arrête.`,
	GrindingEngineStarting: `J'entends un frottement provenant du compartiment moteur au démarrage du véhicule.`,
	GrindingEngineTurning: `J'entends un frottement provenant du compartiment moteur seulement lorsque je tourne.`,
	GrindingEngineNone: `J'entends un frottement provenant du compartiment moteur.`,
	GrindingUnder: `J'entends un frottement provenant d'en dessous du véhicule...`,
	GrindingUnderAll: `J'entends un frottement constant provenant d'en dessous du véhicule.`,
	GrindingUnderStopping: `J'entends un frottement provenant d'en dessous du véhicule lors du freinage.`,
	GrindingUnderTurning: `J'entends un frottement qui vient de dessous du véhicule seulement lorsque je tourne.`,
	GrindingUnderNone: `J'entends un frottement venant d'en dessous du véhicule.`,
	GrindingNone: `J'entends un frottement.`,
	Clunk: `Un bruit sourd`,
	HearClunk: `J'entends un bruit sourd de...`,
	ClunkEngine: `J'entends un bruit sourd provenant du compartiment moteur...`,
	ClunkEngineTurning: `J'entends un bruit sourd du compartiment moteur seulement lorsque je tourne.`,
	Bumps: `Lorsque je passe sur des bosses`,
	ClunkEngineBumps: `Je n'entends un bruit sourd du compartiment moteur que lorsque je passe sur des bosses.`,
	Gear: `Lors d'un changement de vitesse`,
	ClunkEngineGear: `J'entends un bruit sourd provenant du compartiment moteur lorsque je change de vitesse`,
	ClunkEngineNone: `J'entends un bruit sourd provenant du compartiment moteur.`,
	ClunkUnder: `J'entends un bruit sourd provenant d'en dessous du véhicule`,
	ClunkUnderTurning: `J'entends un bruit sourd provenant d'en dessous du véhicule lorsque je tourne.`,
	ClunkUnderBumps: `J'entends un bruit sourd qui vient d'en dessous du véhicule lorsque je passe sur des bosses.`,
	ClunkUnderGear: `J'entends un bruit sourd d'en dessous du véhicule le véhicule en prise.`,
	ClunkUnderNone: `J'entends un bruit sourd provenant d'en dessous du véhicule.`,
	ClunkNone: `J'entends un bruit sourd.`,
	SoundNone: `Le bruit du véhicule n'est pas normal.`,
	ISeeIt: `Je vois le problème (fuite d'huile, témoin, etc.)`,
	See: `Voir`,
	ISee: `Je vois...`,
	Smoke: `Fumée`,
	SeeSmoke: `Je vois de la fumée qui vient de...`,
	SeeSmokeEngine: `Je vois de la fumée provenant du compartiment moteur...`,
	AppearsBlack: `Et elle est noire`,
	BlackSmokeEngine: `Je vois de la fumée noire provenant du compartiment moteur.`,
	AppearsBlue: `Et elle est bleue`,
	BlueSmokeEngine: `Je vois de la fumée bleue provenant du compartiment moteur.`,
	AppearsWhite: `Et elle est blanche`,
	WhiteSmokeEngine: `Je vois de la fumée blanche provenant du compartiment moteur.`,
	SmokeEngineNone: `Je vois de la fumée provenant du compartiment moteur.`,
	ExhaustPipe: `Le tuyau d'échappement`,
	SmokeExhaust: `Je vois de la fumée provenant du tuyau d'échappement...`,
	SmokeExhaustBlack: `Je vois de la fumée noire provenant du tuyau d'échappement.`,
	SmokeExhaustBlue: `Je vois de la fumée bleue provenant du tuyau d'échappement.`,
	SmokeExhaustWhite: `Je vois de la fumée blanche provenant du tuyau d'échappement.`,
	SmokeExhaustNone: `Je vois de la fumée provenant du tuyau d'échappement.`,
	SmokeInterior: `Je vois de la fumée provenant de l'intérieur du véhicule.`,
	PuddleLeak: `Une flaque ou une fuite`,
	SeePuddleLeak: `Je vois une flaque ou une fuite provenant de...`,
	PuddleLeakEngine: `Je vois une flaque ou une fuite qui provient du compartiment moteur et qui ressemble à...`,
	EngineOil: `Huile moteur (brun-noir)`,
	PuddleLeakEngineOil: `Je vois une flaque ou une fuite d'huile moteur dans le compartiment moteur.`,
	TransmissionFluid: `Liquide à transmission (rouge-brun)`,
	PuddleLeakEngineTransmissionFluid: `Je vois une flaque ou une fuite de liquide de transmission dans le compartiment moteur.`,
	PowerSteeringFluid: `Liquide de servodirection (rouge-rose)`,
	PuddleLeakEnginePowerSteeringFluid: `Je vois une flaque ou une fuite de liquide de servodirection dans le compartiment moteur.`,
	Coolant: `Liquide de refroidissement (vert ou orange-jaune)`,
	PuddleLeakEngineCoolant: `Je vois une flaque ou une fuite de liquide de refroidissement dans le compartiment moteur.`,
	Gasoline: `Essence`,
	PuddleLeakEngineGasoline: `Je vois une flaque ou une fuite d'essence dans le compartiment moteur.`,
	PuddleLeakEngineNone: `Je vois une fuite ou une flaque dans le compartiment moteur.`,
	PuddleLeakUnder: `Je vois une flaque ou une fuite sous le véhicule et cela ressemble à...`,
	PuddleLeakUnderEngineOil: `Je vois une flaque ou une fuite d'huile moteur sous le véhicule.`,
	PuddleLeakUnderTransmissionFluid: `Je vois une flaque ou une fuite de liquide de transmission sous le véhicule.`,
	PuddleLeakUnderPowerSteeringFluid: `Je vois une flaque ou une fuite de liquide de servodirection sous le véhicule.`,
	PuddleLeakUnderCoolant: `Je vois une flaque ou une fuite de liquide de refroidissement sous le véhicule.`,
	PuddleLeakUnderGasoline: `Je vois une flaque ou une fuite d'essence sous le véhicule.`,
	PuddleLeakUnderNone: `Je vois une flaque ou une fuite sous le véhicule.`,
	PuddleLeakInterior: `Je vois une flaque ou une fuite à l'intérieur du véhicule qui ressemble à...`,
	Water: `Eau`,
	PuddleLeakInteriorWater: `Je vois une flaque ou une fuite d'eau à l'intérieur du véhicule.`,
	Refrigerant: `Réfrigérant (odeur chimique)`,
	PuddleLeakInteriorRefrigerant: `Je vois une flaque ou une fuite de réfrigérant à l'intérieur du véhicule.`,
	CoolantSmell: `Liquide de refroidissement (odeur chimique)`,
	PuddleLeakInteriorCoolant: `Je vois une flaque ou une fuite de liquide de refroidissement à l'intérieur du véhicule.`,
	PuddleLeakInteriorNone: `Je vois une flaque ou une fuite à l'intérieur du véhicule.`,
	LowFlatTire: `Un pneu dégonflé ou crevé`,
	SeeLowFlatTire: `Je vois un pneu dégonflé ou crevé...`,
	OnDriversSideFront: `Du côté conducteur à l'avant du véhicule`,
	LowFlatTireDriversSideFront: `Je vois un pneu dégonflé ou crevé du côté du conducteur à l'avant du véhicule.`,
	OnDriversSideRear: `Du côté du conducteur, à l'arrière du véhicule`,
	LowFlatTireDriversSideRear: `Je vois un pneu dégonflé ou plat du côté du conducteur à l'arrière du véhicule.`,
	OnPassengersSideFront: `Sur le côté avant du véhicule du passager`,
	LowFlatTirePassengersSideFront: `Je vois un pneu dégonflé ou crevé du côté du passager à l'avant du véhicule.`,
	OnPassengersSideRear: `Du côté du passager, à l'arrière du véhicule`,
	LowFlatTirePassengersSideRear: `Je vois un pneu dégonflé ou crevé du côté du passager à l'arrière du véhicule.`,
	LowFlatTireNone: `Je vois un pneu dégonflé ou crevé.`,
	WarningLight: `Un témoin`,
	ISeeThe: `Je vois le...`,
	CheckEngineLight: `témoin du moteur`,
	SeeCheckEngineLight: `Je vois le témoin du moteur et il est...`,
	OccasionallyOn: `occasionnellement allumé`,
	CheckEngineLightOccasionally: `Je vois le témoin de vérification du moteur à l'occasion.`,
	ConstantlyOn: `Constamment allumé`,
	CheckEngineLightConstantly: `Je vois constamment le témoin de vérification du moteur.`,
	TirePressureWarning: `Témoin de pression de pneu`,
	SeeTirePressureWarning: `Je vois le témoin de pression des pneus et il est...`,
	TirePressureWarningOccasionally: `Je vois le témoin de pression de pneu à l'occasion.`,
	TirePressureWarningConstantly: `Je vois constamment le témoin de pression des pneus.`,
	CoolantTemperatureWarning: `Témoin de liquide de refroidissement/température`,
	SeeCoolantTemperatureWarning: `Je vois le témoin de liquide de refroidissement/température et il est...`,
	CoolantTemperatureWarningOccasionally: `Je vois occasionnellement le témoin de liquide de refroidissement/température.`,
	CoolantTemperatureWarningConstantly: `Je vois constamment le témoin de liquide de refroidissement/température.`,
	BatteryChargeWarning: `Témoin de charge de batterie`,
	SeeBatteryChargeWarning: `Je vois le témoin de charge de betterie et il est...`,
	BatteryChargeWarningOccasionally: `Je vois le témoin de charge de batterie à l'occasion`,
	BatteryChargeWarningConstantly: `Je vois constamment le témoin de charge de batterie.`,
	OilPressureWarning: `Témoin de pression d'huile`,
	SeeOilPressureWarning: `Je vois le témoin de pression d'huile et il est...`,
	OilPressureWarningOccasionally: `Je vois le témoin de pression d'huile l'occasion.`,
	OilPressureWarningConstantly: `Je vois constamment le témoin de pression d'huile.`,
	BrakeABSWarning: `Le témoin de frein/ABS`,
	SeeBrakeABSWarning: `Je vois le témoin de frein/ABS et il est...`,
	BrakeABSWarningOccasionally: `Je vois le témoin de freinage/ABS à l'occasion.`,
	BrakeABSWarningConstantly: `Je vois constamment le témoin de freinage/ABS.`,
	StabilityTractionWarning: `Avertissement de stabilité/traction`,
	SeeStabilityTractionWarning: `Je vois le témoin de stabilité/traction et il est...`,
	StabilityTractionWarningOccasionally: `Je vois le témoin de stabilité/traction à l'occasion.`,
	StabilityTractionWarningConstantly: `Je vois constamment le témoin de stabilité/traction.`,
	OtherWarningLight: `Autre témoin ou message d'avertissement`,
	WarningLightOther: `Je vois un témoin ou un message d'avertissement.`,
	SomethingLooksDifferent: `Il y a quelque chose de visuellement différent dans mon véhicule.`,
	ISmellIt: `Je sens (essence, œufs pourris, brûlures, etc.)`,
	Smell: `Odeur`,
	ISmell: `Je sens...`,
	SmellGasoline: `Je sens l'odeur de l'essence...`,
	SmellGasolineEngine: `Je sens de l'essence dans le compartiment moteur...`,
	SmellGasolineEngineAll: `Je sens constamment de l'essence dans le compartiment moteur.`,
	EngineRunning: `Seulement lorsque le moteur est en marche`,
	SmellGasolineEngineRunning: `Je sens une odeur d'essence dans le compartiment moteur seulement lorsque le moteur est en marche.`,
	SmellGasolineEngineNone: `Je sens une odeur d'essence dans le compartiment moteur.`,
	SmellGasolineUnder: `Je sens une odeur d'essence sous le véhicule...`,
	SmellGasolineUnderAll: `Je sens constamment une odeur d'essence sous le véhicule.`,
	SmellGasolineUnderRunning: `Je sens une odeur d'essence sous le véhicule seulement lorsque le moteur est en marche.`,
	SmellGasolineUnderNone: `Je sens une odeur d'essence sous le véhicule.`,
	SmellGasolineNone: `Je sens une odeur d'essence autour de mon véhicule.`,
	RottenEggsSulfur: `Œufs pourris ou soufre`,
	SmellRottenEggsSulfur: `Je sens une odeur d'œufs pourris ou de soufre en provenance de mon véhicule.`,
	Mildew: `Moisissure`,
	SmellMildew: `Je sens de la moisissure...`,
	SmellMildewAll: `Je sens de la moisissure dans mon véhicule tout le temps.`,
	SmellMildewHeatAC: `Je sens de la moisissure dans mon véhicule uniquement lorsque le chauffage ou le climatiseur est allumé.`,
	SmellMildewNone: `Je sens de la moisissure venant de mon véhicule.`,
	Antifreeze: `Antigel (odeur sucrée)`,
	SmellAntrifreeze: `Je sens de l'antigel dans le...`,
	SmellAntiFreezeEngine: `Je sens de l'antigel dans le compartiment moteur.`,
	SmellAntiFreezeInterior: `Je sens de l'antigel à l'intérieur de mon véhicule...`,
	SmellAntiFreezeInteriorAll: `Je sens constamment de l'antigel à l'intérieur de mon véhicule.`,
	OnlyWhenHeat: `Seulement lorsque le chauffage est activé`,
	SmellAntiFreezeInteriorHeat: `Je sens une odeur d'antigel à l'intérieur de mon véhicule seulement lorsque la chaleur est allumée.`,
	SmellAntifreezeNone: `Je sens une odeur d'antigel venant de mon véhicule.`,
	BurningOil: `Huile brûlante`,
	SmellBurningOil: `Je sens de l'huile qui brûle dans le...`,
	SmellBurningOilEngine: `Je sens de l'huile qui brûle dans le compartiment moteur.`,
	SmellBurningOilExhaust: `Je sens de l'huile qui brûle dans le tuyau d'échappement.`,
	SmellBurningOilNone: `Je sens de l'huile qui brûle dans mon véhicule.`,
	ExhaustGas: `Gaz d'échappement`,
	SmellExhaustGas: `Je sens des gaz d'échappement dans le...`,
	SmellExhaustGasEngine: `Je sens une odeur de gaz d'échappement dans le compartiment moteur...`,
	OnlyDuringStartup: `Seulement pendant le démarrage`,
	SmellExhaustGasEngineStartup: `Je ne sens des gaz d'échappement dans le compartiment moteur seulement pendant le démarrage.`,
	SmellExhaustGasEngineAll: `Je sens constamment des gaz d'échappement dans le compartiment moteur.`,
	SmellExhaustGasEngineNone: `Je sens une odeur de gaz d'échappement dans le compartiment moteur.`,
	SmellExhaustGasInterior: `Je sens des gaz d'échappement à l'intérieur de mon véhicule.`,
	SmellExhaustGasNone: `Je sens une odeur de gaz d'échappement provenant de mon véhicule.`,
	SmellNone: `Il y a quelque chose de différent dans mon véhicule.`,
	VehicleNotFunction: `Mon véhicule ne fonctionne pas (ne démarre pas, ne bouge pas, etc.)`,
	NotFunction: `ne fonctionne pas`,
	MyVehicles: `Mon véhicule a un problème de...`,
	EngineWontStart: `Moteur qui ne démarre pas`,
	MyVehiclesEngine: `Le moteur de mon véhicule...`,
	StartsStalls: `Démarre puis cale immédiatement`,
	EngineStartsStalls: `Le moteur de mon véhicule démarre, puis cale immédiatement.`,
	CranksWontRun: `Tourne mais ne part pas`,
	EngineCranksWontRun: `Le moteur de mon véhicule tourne mais ne tourne pas.`,
	DoesntCrank: `Ne tourne pas du tout`,
	EngineDoesntCrank: `Le moteur de mon véhicule ne tourne pas du tout.`,
	VehiclesEngineWontStart: `Le moteur de mon véhicule tourne mais ne démarre pas.`,
	VentsWontBlowHot: `Les bouches d'aération ne soufflent pas d'air chaud`,
	MyVehiclesVents: `Les bouches d'aération de mon véhicule...`,
	OnlyColdAir: `Soufflent uniquement de l'air froid`,
	VehicleOnlyColdAir: `Mon véhicule ne souffle que de l'air froid.`,
	WontBlowAir: `Ne souffle pas d'air du tout`,
	NoAir: `Les bouches d'aération de mon véhicule ne soufflent pas d'air.`,
	WontBlowHot: `Les bouches d'aération de mon véhicule ne souffleront pas d'air chaud.`,
	VentsWontBlowCold: `Les bouches d'aération ne soufflent pas d'air froid`,
	OnlyWarmAir: `Ne soufflent que de l'air chaud`,
	VehicleOnlyWarmAir: `Mon véhicule ne souffle que de l'air chaud.`,
	WontBlowCold: `Les bouches d'aération de mon véhicule ne souffleront pas d'air froid.`,
	EngineRunsVehicleWontMove: `Le moteur tourne mais le véhicule ne bouge pas`,
	VehiclesEngineRunsVehicleWontMove: `Le moteur de mon véhicule tourne, mais le véhicule ne bouge pas.`,
	MyVehicle: `Mon véhicule ne fonctionnera pas`,
	OtherNone: `Autre (aucune de ces options)`,
	DescribeVehiclesIssue: `Décrivez le problème de votre véhicule:`,
	CalendarDesc: `Votre prochain rendez-vous de service avec`,
	UpcomingServiceAppt: `Votre prochain rendez-vous de service`,
	SvcApptFor: `Rendez-vous service pour`,
	Black: `Noir`,
	Blue: `Bleu`,
	Brown: `Marron`,
	Copper: `Cuivre`,
	Gold: `Or`,
	Gray: `Gris`,
	Green: `Vert`,
	Maroon: `Bordeaux`,
	Orange: `Orange`,
	Pink: `Rose`,
	Purple: `Violet`,
	Silver: `Argent`,
	Tan: `Havane`,
	Teal: `Turquoise`,
	Yellow: `Jaune`,
	SelectDiffTime: `Pour plus d'options, veuillez sélectionner Heure différente ci-dessous.`,
	LogOut: `Fermer la session`,
	AddVehicleTitle: `Ajouter véhicule`,
	recallLink: `https://tc.canada.ca/fr/transport-routier/defauts-rappels-vehicules-pneus-sieges-auto-enfant`,
	DaysLit: 'jour(s)',
	HoursLit: 'heure(s)',
	MinutesLit: 'minute(s)',
	WeOwe: `Nous devons`,
	ManufacturerRecall: `Rappel du fabricant`,
	ServicesOnRepair: 'Services sur cette réparation.',
	EmptyFieldError: `L'entrée est requise pour continuer`,
	At: 'à',
	Please: `Veuillez `,
	SchNewAppt: 'Cliquez pour commencer un nouveau rendez-vous',
	IdenticalPassword: `Les nouveaux et anciens mots de passe sont identiques`,
	NewPassword: `Votre nouveau mot de passe ne peut pas etre le meme que votre mot de passe actuel.`,
	ValidPhone: `Veuillez entrer un numéro de téléphone valide à 10 chiffres.  XXX-XXX-XXXX`,
	ValidEmail: `Veuillez saisir une adresse e-mail valide. Une adresse e-mail valide doit inclure un nom d'utilisateur, un domaine et un domaine de premier niveau. Exemple: johndoe@domain.com`,
	EmailOrPhone: `Courriel ou numéro de téléphone *`,
	ValidEmailPhone: `Veuillez saisir un courriel valide ou un numéro de téléphone à 10 chiffres`,
	Edit: 'Modifier',
	CancelToolTip: `Sélectionnez Annuler pour annuler les modifications apportées à votre {0}`,
	FirstNameLabel: `Prénom`,
	LastNameLabel: `Nom de famille`,
	PhoneLabel: `Numéro de telephone`,
	NoAvailTimes: `Aucun horaire disponible pour la date sélectionnée`,
	NotAvailDate: `Non disponible pour la date sélectionnée`,
	SessionExpired: `Votre session a expiré. Veuillez actualiser la page`,
	ConnectedVehicle: `VÉHICULE CONNECTÉ`,
	ConnectedVehicleStatus: `Statut du véhicule connecté`,
	Client: `Client`,
	VINShort: `NIV`,
	LastDataRefresh: `Dernière actualisation des données`,
	VehMaintenance: `ENTRETIEN VÉHICULE`,
	VehStatus: `STATUT VÉHICULE`,
	DTCHeader: `Codes de problème de diagnostic`,
	TroubleCode: `Code de problème`,
	CVStatus: `Statut`,
	DTCShort: `DTC`,
	EmissionDTC: `Émission DTC`,
	ECMECU: `ECM/ECU`,
	SymptomCode: `Code symptôme`,
	ViewVehicleBuildData: `Afficher les données d'assemblage du véhicule`,
	ViewConnectedVehicleLog: `Afficher le journal Connectés du véhicule`,
	ViewConnectedVehicleSettings: `Afficher les paramètres Connectés du véhicule`,
	ViewManufacturerInquiry: `Afficher l'interrogation du fabricant`,
	ViewGeoLocation: `Afficher la géolocalisation`,
	ViewServiceHistory: `Afficher l'historique de service`,
	ServiceHistory: `Historique du service`,
	FirstRepairOrderDate: `Date premier bon de travail`,
	LastRepairOrderNumber: `#Dernier bon de travail`,
	LastRepairOrderDate: `Date dernier bon de travail`,
	LastRepairOrderOdometer: `Odomètre dernier bon de travail`,
	RONum: `BT`,
	DealerCode: `Code concessionnaire`,
	LocationId: `ID lieu`,
	OpenDate: `Date ouverture`,
	CompletedDate: `Complété le`,
	InvoicedDate: `Date facturé`,
	OodmeterIn: `Odomètre entrée`,
	OdometerOut: `Dehors`,
	JobNumber: `Numéro d'activité`,
	OperationId: `ID opération`,
	OperationDescription: `Description`,
	LaborId: `ID main-d'œuvre`,
	LaborHours: `Heures main-d'œuvre`,
	LaborDescription: `Description main-d'œuvre`,
	PartNumber: `Numéro pièce`,
	PartQty: `Qté pièce`,
	PartDescription: `Description pièce`,
	BuildData: `DATE CREATION`,
	VehicleInformation: `Informations véhicule`,
	VehicleDetails: `Détails véhicule`,
	BuildCodes: `Codes d'assemblage`,
	ProductionDate: `Date production`,
	Series: `Séries`,
	ModelNumber: `#Modèle`,
	ColorCode: `Couleur (code)`,
	InteriorCode: `Habitacle (code)`,
	MarketName: `Nom marché`,
	BodyStyle: `Style de carrosserie`,
	OrderNumber: `#Commande`,
	ProductionPoint: `Lieu de production`,
	ProductionPlant: `Lieu de production (code)`,
	SerialNumber: `Numéro de série`,
	AirConditioning: `Climatisation`,
	PowerSteering: `Direction assistée`,
	Turbo: `Turbo`,
	LicenseNumber: `Numéro permis de conduire`,
	NewUsed: `Neuf/Occasion`,
	ChassisNumber: `Nombre de châssis`,
	KeyNumber: `Numéro de clé`,
	SecondKeyNumber: `Deuxième numéro de clé`,
	KeylessNumber: `Numéro sans clé`,
	KeychipNumber: `Numéro de la puce à clé `,
	AlarmNumber: `Numéro de l'alarme`,
	FrontSafetyRating: `Cote de sécurité à l'avant`,
	RearSafetyRating: `Cote de sécurité à l'arrière`,
	DriverSafetyRating: `Cote de sécurité conducteur`,
	PassengerSafetyRating: `Cote de sécurité passager`,
	RolloverSafetyRating: `Cote de sécurité capotage`,
	OverallSafetyRating: `Cote de sécurité globale`,
	SeatingCapacity: `Nombre de places assises`,
	GrossVehicleWeight: `Poids brut du véhicule`,
	VehicleWeight: `Poids du véhicule`,
	EngineNumber: `Nombre de moteurs`,
	EngineConfiguration: `Configuration du moteur`,
	EngineSize: `Taille du moteur`,
	EngineType: `Type moteur`,
	EngineCylinders: `Cylindres du moteur`,
	BaseMSRP: `Base PDSF`,
	OptionMSRP: `Option PDSF`,
	TotalMSRP: `Total PDSF`,
	Freight: `Fret`,
	ModelPhaseCode: `Code de phase du modèle`,
	FuelCode: `Code du carburant`,
	FuelType: `Type de carburant`,
	FuelCapacity: `Capacité en carburant`,
	Transmission: `Boîte de vitesses`,
	TransmissionCode: `Code de transmission`,
	TransmissionDescription: `Description de la transmission`,
	StockId: `ID stock`,
	CustomerNumber: `Numéro client`,
	SalesmanNumber: `Numéro vendeur`,
	ModelMaintenanceCode: `Code entretien modèle`,
	SellingDealerNumber: `Numéro Concession vendeuse`,
	InServiceDate: `Date au service`,
	ProductionHour: `Heure de production`,
	DeliveryDate: `Date livraison`,
	DeliveryOdometer: `Odomètre à la livraison`,
	DemoDate: `Date démo`,
	DemoOdometer: `Odomètre démo`,
	FactoryWarrExpDate: `Date d'expiration de la garantie d'usine`,
	FactoryWarrExpOdometer: `Odomètre d'expiration de garantie d'usine`,
	ServiceDays: `Jours de service`,
	TeamCode: `Code équipe`,
	LastActivityDate: `Date dernière activité`,
	DriverWindowReedSensor: `Pulsions du capteur Reed de la fenêtre du conducteur`,
	PassengerWindowReedSensor: `Pulsions du capteur Reed de la fenêtre du passager`,
	RearLeftWindowReedSensor: `Pulsions du capteur Reed de la fenêtre arrière gauche`,
	RearRightWindowReedSensor: `Pulsions du capteur Reed de la fenêtre arrière droite`,
	SunroofReedSensor: `Pulsions du capteur Reed du toit ouvrant`,
	OptionDesc: `Description option`,
	OptionCode: `Code`,
	ConnectedVehicleLog: `JOURNAL CONNECTÉS DU VÉHICULE`,
	EventDescription: `Description de l'événement`,
	CVDate: `Date`,
	CVTime: `Heure`,
	ERAUser: `Usager ERA`,
	ManufacturerInquiry: `DEMANDE DU FABRICANT`,
	VehicleLocation: `Emplacement véhicule`,
	LocationAsOf: `Lieu au`,
	GpsStatus: `Statut GPS`,
	GpsState: `GPS Province`,
	Mileage: `Kilométrage`,
	BatteryCharge: `Charge de batterie`,
	BatteryInformation: `Informations sur la batterie`,
	Battery: `Batterie`,
	LastUpdated: `Dernière mise à jour`,
	BatteryStatus: `État de la batterie`,
	BatteryHealthStatus: `État de santé de la batterie`,
	BatteryChargePercent: `Charge de batterie (%)`,
	ElectricBatteryDTE: `Batterie électrique DTE`,
	FuelLevel: `Niveau de carburant`,
	FuelInformation: `Informations sur le carburant`,
	Fuel: `Carburant`,
	MilesPerFullTank: `Km avec réservoir plein`,
	CityMpg: `L/100Km ville`,
	FuelEquivalentCityMpg: `Equiv. carburant L/100Km ville`,
	HighwayMpg: `L/100Km route`,
	FuelEquivalentHighwayMpg: `Equiv. carburant L/100Km route`,
	CombinedMpg: `L/100 combinés`,
	FuelEquivalentCombinedMpg: `Equiv. carburant L/100 combinés`,
	DistanceToEmpty: `Distance à vide`,
	OilLife: `Durée de vie de l'huile`,
	OilInformation: `Informations sur l'huile`,
	Oil: `Huile`,
	OilStatus: `État de l'huile`,
	OilAmount: `Quantité d'huile`,
	OilDescription: `Description de l'huile`,
	RemainingDistance: `Distance restante`,
	ReplaceOil: `Remplacer l'huile`,
	ZeroDaysMonthsYears: `Zéro Jours/Mois/Années`,
	LockStatus: `État des serrures`,
	Locked: `Verrouillé`,
	Unlocked: `Déverrouillé`,
	AlarmStatus: `État de l'alarme`,
	Set: `Configuré`,
	NotSet: `Non configuré`,
	Working: `Fonctionnel`,
	NotWorking: `Non fonctionnel`,
	RemoteStartStatus: `État de démarrage à distance`,
	RemoteStartInformation: `Informations de démarrage à distance`,
	RemoteStartCommand: `Commande de démarrage à distance`,
	RemoteStart: `Démarreur à distance`,
	Duration: `Durée`,
	TimeRemaining: `Temps restant`,
	ExhaustFluid: `Liquide d'échappement`,
	EngineAirFilter: `Filtre à air du moteur`,
	RepeatVisits: `Visites répétées`,
	DeepSleep: `Sommeil profond`,
	FirmwareUpdate: `Mise à jour du micrologiciel`,
	EvHybridData: `Données sur les véhicules électriques et hybrides`,
	EvHybridInformation: `Afficher données sur les véhicules électriques et hybrides`,
	ViewEvHybridData: `Informations sur les véhicules électroniques et hybrides`,
	PlugStatus: `État de la prise`,
	HybridChargingMode: `Mode de chargement hybride`,
	ChargeStatus: `État du chargement`,
	ChargeStartTime: `Heure de début du chargement`,
	ChargeEndTime: `Heure de fin du chargement`,
	PrivacyConsent: `Consentement relatif à la confidentialité`,
	PrivacyInformation: `Informations sur la confidentialité`,
	PrivacyCompanyName: `Nom de l'entreprise de confidentialité`,
	PrivacyStartDate: `Date de début de la confidentialité`,
	PrivacyDevice: `Appareil de confidentialité`,
	VisitInformation: `Informations sur la visite`,
	VehicleVisitId: `Code de visite du véhicule`,
	CheckInDate: `Date d'inscription`,
	DealerName: `Nom concessionnaire`,
	ConnectedVehicleSettings: `Paramètres Connectés du véhicule`,
	DeviceName: `Nom de l'appareil`,
	TeleserviceCapabilities: `Capacités de téléservice`,
	RemoteTeleserviceCalls: `Appels de téléservice à distance`,
	TeleserviceContract: `Contrat de téléservice`,
	TelemetryLastUpdated: `Dernière mise à jour de la télémétrie`,
	ServiceSafetyCampaignSSCIndicator: `Indicateur de campagne de sécurité des services (SSC)`,
	Damaged: `Endommagé`,
	VehicleLastUpdated: `Dernière mise à jour du véhicule`,
	VehicleCheckCode: `Code de vérification du véhicule`,
	DealerCategory: `Catégorie concessionnaire`,
	SupplyChainCategory: `Catégorie chaîne d'approvisionnement`,
	Authorization: `Autorisation`,
	LocationData: `Données de localisation`,
	VehicleConnectivity: `Connectivité du véhicule`,
	VehicleData: `Données véhicule`,
	Safety: `Sécurité`,
    ServiceConnect: `Connexion aux services`,
    Remote: `Télécommande`,
    DigitalKeyRemote: `Télécommande à clé numérique`,
    DestinationAssist: `Aide à la destination`,
    Navigation: `Navigation`,
    VirtualAssist: `Assistant virtuel`,
    IntegratedStreaming: `Diffusion intégrée`,
    Wifi: `Wi-Fi`,
    Active: `ACTIF`,
    NotActive: `NON ACTIF`,
	OdometerInformation: `Informations sur l'odomètre`,
	AvgDistancePerWeek: `Distance moyenne par semaine`,
	CheckEngLight: `Témoin d'anomalie`,
	LFTirePressure: `Pression du pneu AvG`,
	RFTirePressure: `Pression du pneu AvD`,
	LRTirePressure: `Pression du pneu ArG`,
	RRTirePressure: `Pression du pneu ArDG`,
	SpareTirePressure: `Pression du pneu de secours`,
	TireInformation: `Informations sur les pneus`,
	General: `Général`,
	TireSpeed: `Vitesse des pneus`,
	TirePressureStatus: `Témoin de pression des pneu`,
	TirePressureByLocation: `Pression des pneus par emplacement`,
	TirePressureSystem: `Système de pression des pneus`,
	FrontTires: `Pneus avant`,
	RecommendedFrontPressure: `Pression avant recommandée`,
	LeftFrontTirePressure: `Pression du pneu avant gauche`,
	RightFrontTirePressure: `Pression du pneu avant droit`,
	LeftFrontTireStatus: `État du pneu avant gauche`,
	RightFrontTireStatus: `État du pneu avant droit`,
	RearTires: `Pneus arrière`,
	RecommendedRearPressure: `Pression arrière recommandée`,
	DualRearWheels: `Roues arrière jumelées`,
	LeftRearTirePressure: `Pression du pneu arrière gauche`,
	RightRearTirePressure: `Pression du pneu arrière droit`,
	LeftRearTireStatus: `État du pneu arrière gauche`,
	RightRearTireStatus: `État du pneu arrière droit`,
	InnerLeftRearTirePressure: `Pression interne du pneu arrière gauche`,
	InnerRightRearTirePressure: `Pression interne du pneu arrière droit`,
	InnerLeftRearTireStatus: `État du pneu arrière intérieur gauche`,
	InnerRightRearTireStatus: `État du pneu arrière intérieur droit`,
	SpareTire: `Pneu de secours`,
	SpareTireStatus: `Pression du pneu de secours`,
	DataFrom: `Données de`,
	DataAsOf: `Données au`,
	AsOf: `au`,
	IndicatorOn: `Indicateur activé`,
	IndicatorOff: `Indicateur désactivé`,
	Outer: `extérieur`,
	Inner: `intérieur`,
	DealershipVisits: `Visites au concessionnaire`,
	RecallsAndCampaigns: `Rappels de véhicules et campagnes`,
	OpenCampaigns: `Campagne(s) ouverte(s)`,
	RecommendedMaintenance: `Entretien recommandé`,
	MaintenanceContracts: `Contrats d'entretien`,
	EnrollmentDate: `Date d'inscription`,
	EffectiveDate: `Date d'entrée en vigueur`,
	ExpirationDate: `Date d'expiration`,
	StartDate: `Date de début`,
	SoldBy: `Vendu par`,
	SoldTo: `Vendu à`,
	ContractDetails: `Détails du contrat`,
	ViewContractDetails: `Afficher les détails du contrat`,
	Infonet: `Infonet`,
	ContractType: `Type de contrat`,
	ContractCode: `Code du contrat`,
	CVMileage: `Kilométrage`,
	Deductible: `Déductible`,
	Vendor: `Fournisseur`,
	Message: `Message`,
	AccountNum: `#Compte`,
	Available: `Disponible`,
	MSRP: `MSRP`,
	Wholesale: `Vente au gros`,
	ExpirationMonths: `Mois d'expiration`,
	CVMiles: `kilomètres`,
	DueDate: `Date d'échéance`,
	Distance: `Distance`,
	OpCode: `Code Op`,
	ID: `ID`,
	Source: `Source`,
	CampaignCode: `Code campagne`,
	BulletinId: `ID du bulletin`,
	RecallId: `ID du rappel`,
	Remedy: `Recours`,
	StopSale: `Arrêt de vente`,
	StopSaleCode: `Code d'arrêt de vente`,
	ReservedByDealership: `Réservé par concessionnaire`,
	PartsRequired: `Parts Required`,
	RepairTime: `Repair Time`,
	SelectAllStatuses: `Sélectionner tous les états`,
	ImportSelectedStatuses: `Importer les états sélectionnés dans le BT`,
	SelectAllDTC: `Sélectionner tous DTC.`,
	ImportSelectedDTC: `Importer le DTC sélectionné dans BT`,
	SelectAllCampaigns: `Sélectionner toutes les campagnes`,
	ImportSelectedCampaigns: `Importer les campagnes sélectionnées dans BT`,
	SelectAllRecom: `Sélectionner tous enreg. Maint.`,
	ImportSelectedRecom: `Importer enreg. sélectionnés Maint. au BT`,
	On: `Activé`,
	Off: 'Désactivé',
	NoReportCard: `Aucune fiche de rendement pour ce bon de travail.  Les données de pression des pneus n'ont pas pu être importées.`,
	ReportCardComplete: `La fiche de rendement de ce bon de travail est déjà terminée.  Les données de pression des pneus n'ont pas pu être importées.`,
	AnErrorOccurred: `Une erreur s'est produite : `,
	RefreshRepair: `Actualiser l'état de la réparation`,
	RefreshToolTip: `Cliquez ici pour actualiser l'état de la réparation`,
	WhatIsThis: `Qu'est-ce que c'est?`,
	AsOf2: `À`,
	On2: `le`,
	OSDDocDisplayDate: `{0} le {1}`,
	RecommendedServices: `Services Recommandés`,
	viewEdit: `Afficher/Modifier`,
	AutomatedVehicleQueryRemote: `Requête de véhicule automatisée - À distance'`,
	AutomatedVehicleQueryVehiclePresent: `Requête de véhicule automatisée - Véhicule présent`,
	ManualVehicleQuery: `Recherche manuelle de véhicule`,
	AllTypes: `Tous les types`,
	AllSpgOptions: `Tous`,
	AllSpgEngines: `Tous`,
	CurrentMonth: `Mois en cours`,
	LastMonth: `Last Month`,
	Last6Months: `Le mois dernier`,
	LastYear: `Last Year`,
	AllDates: `L'année dernière`,
	ImportActionSelected: `Action d'importation sélectionnée`,
	EnteredIssueError: `Un problème saisi n'a pas été ajouté au panier. Souhaitez-vous ajouter le problème maintenant?`,
	InvalidFunction: 'Fonction invalide',
	PleaseRefresh: 'Fonction non valide, veuillez actualiser.',
	RefreshError: `Erreur d'actualisation - veuillez réessayer`,
	MaintContractDetails: 'Maintenance Contract Details',
    MaintenanceContract: 'Maintenance Contract',
    MaintContractSubheading1: 'The following maintenance contracts are linked to your vehicle.',
    MaintContractSubheading2: 'Some services may be reduced to $0.00 depending on your coverage.',
    MaintContractSubheading3: 'Please ask your service advisor for more information.',
    MaintContractMessage: 'Some services may be reduced to $0.00 based on your Maintenance Contract coverage.',
    NoMaintContractsFound: 'No maintenance contracts were found for your vehicle',
	ContractIncludesNumItems: 'This Contract includes {0} items:',
    ProvidedBy: 'Provided By',
	CheckMaintContract: 'Check for maintenance contracts for vehicle',
    vehWhichMaintContract: 'Which vehicle would you like to check for maintenance contracts?',
    CheckContracts: 'Check Contracts',
    CheckMC: 'Click the button below to check if there are any maintenance contracts for your vehicle.',
    MaintContractTip: 'Click to check for maintenance contracts for your vehicle',
    MaintContractError: 'We are unable to check your vehicle for maintenance contracts at this time. Please contact the dealership to see if maintenance contracts are linked to your vehicle.',
    MaintContractLinked: 'The following maintenance contracts are linked to your {0} {1}. ',
    PullingMaintContracts: 'We are pulling your maintenance contracts right now. Please wait...',
	NoOustandingMC: 'No maintenance contracts were found for your ',
    VehNoMC: 'No maintenance contracts were found for this vehicle.',
    WhereIsMyVIN: `Où est mon NIV?`,
    WhereVinHeader: `Numéro d'identification du véhicule (NIV)`,
    TypicalVINLoc: `Emplacements typiques du NIV sur votre véhicule`,
    OtherVinLoc: `Autres emplacements de NIV:`,
    InsuranceIdCard: `Carte d'identité d'assurance`,
    VehRegCard: `Carte grise du véhicule`,
    MaintenanceContractsFound: 'Maintenance Contracts Found',
	DeptChangeWarning: `Avertissement de changement de service`,
	DeptChangeMessage: `Les modifications que vous avez apportées pourraient affecter la date et/ou l'heure du rendez-vous disponible.  Voulez-vous continuer?`,
	MonthsCovered: 'Months Covered',
	ContractCategory: 'Contract Category',
	Form: 'Form#',
	FormMonth: 'Form Month',
	FormYear: 'Form Year',
	ServiceStatus: 'Service Status',
	ServiceTypeNumber: 'Service Type Number',
	ServiceInterval: 'Service Interval',
	Months: 'months',
	NonVinMaintMenuDisclaimer: `**Tous les prix affichés sont des estimations basées sur les informations disponibles. Les prix finaux peuvent différer.**`,
	KeyReadDate: 'Key Read Date',
	KeyWriteDate: 'Key Write Date',
	AddAnotherAppointment: `Souhaitez-vous ajouter un autre rendez-vous?`,
	RecallDetails: `Détails du rappel`,
	VehCommunications: 'VEHICLE COMMUNICATIONS',
	CommunicationType: 'Communication Type',
	Code: 'Code',
	Feature: 'Feature',
	Urgency: 'Urgency',
	Confidence: 'Confidence',
	Condition: 'Condition',
    CommTime: 'Time',
	DidNotFindYou: `Je ne t'ai pas trouvé`,
    ImNewHere: `Je suis nouveau`,
    KeepSearching: `Continuons nos recherches!`,
    NationwideVehicleSearch: `We couldn\'t find you using {0}. Please enter your First and Last Name to do a nationwide vehicle search or select skip to add an appointment as a new customer.`,
    NationwideVehiclesFound: `A nationwide vehicle search found the following vehicle(s) using your information. Do you want to add one of these vehicles to your account?`,
    RequiredFieldsToSearch: `Required fields to search are marked with an asterisk "*"`,
	FirstNameLengthError: `Le prénom ne peut pas contenir plus de 30 caractères`,
    LastNameLengthError: `Le nom de famille ne peut pas contenir plus de 30 caractères`,
	VehicleAddErrorSPM: `Nous rencontrons des difficultés pour ajouter votre véhicule en ce moment.`,
    ValidNameLength: `Le prénom + le nom ne peuvent pas comporter plus de 35 caractères.`,
    ValidEmailLength: `L'e-mail ne peut pas comporter plus de 62 caractères.`,
    ValidCity: `La ville ne peut pas comporter plus de 20 caractères.`,
    ValidStreet: `L'adresse ne peut pas comporter plus de 30 caractères.`,
	TransRemoveWarnMsg: `Les services ne peuvent pas être supprimés lorsque {0} est sélectionné.`,
    TransRemoveSelTimeWarnMsg: `Veuillez confirmer une date et une heure avant de supprimer des services.`,
	GMRewardsDisclaimerServc: `*Les services peuvent donner droit à des points Mes Récompenses GM. Veuillez demander plus d'informations à votre conseiller en service.*`,
	EstimatedGMRewards: `Est disponible Mes récompenses GM:`,
	MinCostAfterRewards: `Coût minimum est avec Mes récompenses GM:`,
	MinEstCostGM: 'Coût minimum estimé:',
	DollarGM: '$',
	GMRewardsDisclaimerSummary: `Les services peuvent donner droit à des points Mes Récompenses GM. Veuillez demander plus d'informations à votre conseiller.`,
	NotEligibleService: `Non éligible aux services sélectionné`,
	ClickToAdd: `Cliquez pour confirmer et ajouter votre rendez-vous`,
	//Pickup and Delivery
    PickupLocation: `Lieu de ramassage`,
    DropOffLocation: `Point de chute`,
    SameAsCheckBox: `Identique au lieu de prise en charge`,
    PULSubHeaderMessage: `Préparons l'endroit où votre véhicule sera récupéré et déposé après le service.`,
    PULHeaderNoName: `Où est votre véhicule?`,
    StreetAddressErrMsg1: `Veuillez utiliser uniquement des chiffres, des lettres et des espaces`,
    StreetAddressErrMsg2: `Ce champ est obligatoire, veuillez saisir une adresse postale.`,
    CityErrMsg: `Veuillez entrer une ville.`,
    StateErrMsg: `Veuillez sélectionner l'une des options déroulantes`,
    ZIPCodeErrMsg: `Veuillez saisir un code postal valide à 5 ou 9 chiffres`,
    PostalCodeErrMsg: `Veuillez saisir un code postal valide à 6 chiffres au format A1A 1A1`,
    StreetAddress2: `Adresse municipale 2`,
    AdditionalComments: `Commentaires supplémentaires...`,
    CharactersRemaining: ` caractères restants...`,
	ChangeInfoErrMsg: `Nous ne sommes pas en mesure de mettre à jour vos informations pour le moment. Veuillez contacter le concessionnaire pour mettre à jour vos informations.`,
	Information: `Information`,
	StatusNotStarted: `Non démarré`,
	LetsGetStarted: `Commençons`,
	LetsGo: `Allons-y`,
	MyAccount: `Mon compte`,
	ContinueAsGuest: `Continuer en tant qu'invité`,
	ImNew: `je suis nouveau`,
	GuestPrompt: `Je suis nouveau ici. Je souhaite choisir manuellement l'année/le modèle de mon véhicule pour accéder aux informations de planification de base.`,
	ViewPastRecalls: `Rappels et campagnes passés`,
    PastRecalls: `Rappels et campagnes passés`,
    RecallStatus: `Statut`,
    RemedyNotAvailable: `Remède non disponible`,
	WhatIsRemedyNotAvail: `Remède non disponible signifie qu'un rappel incomplet ou "ouvert" a été trouvé pour votre véhicule, mais que le fabricant n'est pas encore prêt à fournir le remède ou la solution nécessaire.`,
	PricingConfirmedUponArrival: `*Le prix sera confirmé à l'arrivée`,
	Engagement: 'Engagement',
	LoyaltyActiveStatus: `An Active customer who has transacted (sale/service) with the PMA dealer (but not any other Toyota dealer 2x consecutive times) in the past 12 months.`,
    LoyaltyInactiveStatus: `An Inactive customer who has transacted (sale/service) with the PMA dealer (but not any other Toyota dealer 2x consecutive times) in the past 7 years. Also, it has been at least 12 months since the last transaction with the PMA dealer.`,
    LoyaltyCrossStatus: `A Cross Active customer who purchased or serviced 2x consecutive times at another nonPMA Toyota Dealer.`,
    LoyaltyNoStatus: `A Not Engaged customer who has not transacted (sale/service) with the PMA dealer (or any other Toyota dealer 2x consecutive times) in the past 12 months.`,
    LoyaltyOtherStatus: `Other.`,
};
